export const DEFAULT_AMAZON_LINK = "https://amzn.to/4swGTOe";

export function getShowAmazonLink(show) {
  return show?.amazonLink ?? null;
}
